import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../utils/ua';

import './style.less';

export default class DownloadPage extends Component {
    constructor(props){
        super(props);
        console.log(UA)
        if(UA.ipad) window.location.href = 'https://itunes.apple.com/cn/app/id1431703239';
        else if(UA.iphone) window.location.href = 'https://itunes.apple.com/cn/app/id1431699300';
        else window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.pandaabc.stu';
        this.state = {};
    }
    render(){
        return(
            <DocumentTitle title={'跳转中...'}>
                <div className="container download"></div>
            </DocumentTitle>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/customerPage/DownloadPage.jsx